(function () {
  const pixelId = "PQvgapLuh4FoT4PVxmUaob";
  let initialized = false;
  let measurementAllowed = false;
  const pendingEvents = [];

  if (!window.oaiq) {
    const queue = function () {
      queue.q.push(arguments);
    };
    queue.q = [];
    window.oaiq = queue;

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://bzrcdn.openai.com/sdk/oaiq.min.js";
    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  }

  function initializePixel() {
    if (initialized) return;
    window.oaiq("consent", measurementAllowed);
    window.oaiq("init", { pixelId });
    initialized = true;
  }

  function measure(eventName, data) {
    if (!initialized || !measurementAllowed) {
      pendingEvents.push([eventName, data]);
      return;
    }
    dispatch(eventName, data);
  }

  function dispatch(eventName, data) {
    try {
      window.oaiq("measure", eventName, data);
    } catch (error) {
      return;
    }
  }

  function updateConsent() {
    const customerPrivacy = window.Shopify?.customerPrivacy;
    if (!customerPrivacy) return;

    measurementAllowed =
      customerPrivacy.marketingAllowed() &&
      customerPrivacy.saleOfDataAllowed();
    if (!initialized) {
      initializePixel();
    } else {
      window.oaiq("consent", measurementAllowed);
    }

    if (measurementAllowed) {
      while (pendingEvents.length) {
        dispatch(...pendingEvents.shift());
      }
    } else {
      pendingEvents.length = 0;
    }
  }

  function loadConsentApi() {
    if (window.Shopify?.customerPrivacy) {
      updateConsent();
      return;
    }
    if (typeof window.Shopify?.loadFeatures !== "function") return;

    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.2" }],
      (error) => {
        if (!error) updateConsent();
      },
    );
  }

  loadConsentApi();
  document.addEventListener("visitorConsentCollected", updateConsent);

  const pageContext = window.openAIAdsPageContext || {};
  measure("page_viewed", {
    type: "contents",
    contents: [
      {
        id: String(pageContext.contentId || window.location.pathname),
        name: pageContext.pageTitle || document.title,
        content_type: "page",
      },
    ],
  });

  if (pageContext.pageType === "product" || pageContext.pageType === "collection") {
    const content = {
      id: String(pageContext.contentId),
      name: pageContext.contentName,
      content_type: pageContext.pageType,
    };
    const viewData = { type: "contents", contents: [content] };
    if (Number.isInteger(pageContext.amount) && pageContext.currency) {
      viewData.amount = pageContext.amount;
      viewData.currency = pageContext.currency;
    }
    measure("contents_viewed", viewData);
  }

})();
